"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApis = void 0;
const config_1 = require("./config");
exports.getApis = () => {
    const model = config_1.getReleoxOption('loginModelName');
    return {
        MEMBER: `${config_1.getApiUrl()}/${model}`,
        LOGIN: `${config_1.getApiUrl()}/${model}/login`,
        FORGOT: `${config_1.getApiUrl()}/${model}/reset`,
        PASSWORD_RESET: `${config_1.getApiUrl()}/${model}/reset-password`,
        LOGOUT: `${config_1.getApiUrl()}/${model}/logout`,
        PATCH: `${config_1.getApiUrl()}/${model}`,
        CONFIRM: `${config_1.getApiUrl()}/${model}/confirm?uid=:userId&token=:confirmationToken`,
        ACCEPT_INVITATION: `${config_1.getApiUrl()}/${model}/accept-invitation?uid=:userId&invitation_token=:invitationToken`,
        VALIDATE_INVITATION_TOKEN: `${config_1.getApiUrl()}/${model}/validate-invitation-token?uid=:userId&invitation_token=:invitationToken`,
        VALIDATE_ACCESS_TOKEN: `${config_1.getApiUrl()}/${model}/:userId?access_token=:accessToken`,
    };
};
//# sourceMappingURL=apis.js.map